import React from 'react';
import StorageAPI from '../../apis/storage_api';
import PhoneInput from '../molecules/phoneInput';
import {WarnerMedia} from '../../endpoints';

class PhoneSignup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.props.createAccount.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event, phone) {
    event.preventDefault();
    const rawCookieData = StorageAPI.get('br_registration');
    const cookieData = rawCookieData ? JSON.parse(rawCookieData) : {};
    const {first_name, last_name, username} = cookieData;
    this.props
      .createAccount({phone, username, first_name, last_name})
      .then(() => {
        this.props.mParticleUpdateAttributes({
          account_verified: false,
          loggedIn: false,
          signup_method: 'phone',
        });
        this.setState({errors: []});
        StorageAPI.set('br_phone', phone);
        this.props.stepCompleted();
      })
      .catch((err) => {
        this.setState({errors: [err]});
      });
  }

  render() {
    return (
      <PhoneInput
        errors={this.state.errors}
        onSubmit={this.onSubmit}
        buttonText="Continue"
        title="Sign Up with Your Phone"
        legalDisclaimer={
          <p>
            By signing up, you agree to the terms and conditions of the Bleacher Report{' '}
            <a href="/pages/terms">Terms of Use</a> and{' '}
            <a href={WarnerMedia.privacy()}>Privacy Policy</a>.
          </p>
        }
      >
        {this.props.children}
      </PhoneInput>
    );
  }
}

export default PhoneSignup;
